import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { constant, debounce } from 'lodash';
import { ProductService } from 'src/app/api/catalog/product.service';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { TourService } from 'src/app/api/tourism/tour.service';
import { constants } from 'src/app/constants';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-product',
  templateUrl: './search-product.component.html',
  styleUrls: ['./search-product.component.css']
})
export class SearchProductComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedProductEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;
  @Input() typeProduct: number | null = null;
  @Input() controlStock: boolean | false = false;
  @Input() placeholderText: string | null = "Buscar producto";
  @Input() searchAll: boolean | false = false;

  data = [];
  keyword = 'description_str';
  isTypedSearch = false;
  classSearch:any;

  constructor(private productService: ProductService) {}

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchHotels(event), 250);

  getSearchHotels(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_+'&type_product=' + this.typeProduct+'&is_control_stock='+ this.controlStock;   
      if(this.searchAll){
        this.productService.searchAll(val_params).subscribe({
          next: (data: any) => {
            this.data = data.results;
            this.data.map((item:any) => item.description_str = `${item.description} ${item.code}`);
          }
        });
      } else{
        this.productService.search(val_params).subscribe({
          next: (data: any) => {
            this.data = data.results;
            this.data.map((item:any) => item.description_str = `${item.description} ${item.code}`);
          }
        });
      }       
      
    } else {
      this.data = [];
    }
  }

  selectSearchProduct(item: any) {
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);

    // this.closedSearchPanel();
    this.selectedProductEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }
}

